import React, { FC, ReactNode } from 'react';
import { Box, Button, Divider, IconButton, Typography } from '@mui/material';
import { i18n } from 'src/common/i18n/i18n';
import { IconXWindow } from 'src/common/images';

export interface DataGridAction {
    icon: ReactNode;
    label: string | ((items: any[]) => string);
    actionFun: ((items: any[]) => void) | (() => void);
    singleItemAction?: boolean;
    isItemsDisabled?: ((items: any[]) => boolean) | (() => boolean);
}

interface CustomDataGridActionsBarProps {
    selectedItemIds: any[];
    onClearSelection: () => void;
    actions: DataGridAction[];
    styles?: any;
}

const CustomDataGridActionsBar: FC<CustomDataGridActionsBarProps> = ({
    selectedItemIds,
    actions,
    onClearSelection,
    styles,
}) => (
    <Box
        sx={{
            width: 464,
            height: 56,
            p: 1,
            position: 'absolute',
            bottom: '36px',
            zIndex: 1,
            left: '50%',
            borderRadius: '8px',
            transform: 'translate(-50%, 0)',
            boxShadow: '0px 6px 40px -4px #919EABB8',
            display: selectedItemIds.length ? 'flex' : 'none',
            alignItems: 'center',
            justifyContent: 'space-between',
            border: '1px solid',
            ...styles,
        }}
        className="background-color-l border-color-bl data-table-actions-bar"
    >
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Box
                sx={{
                    width: 40,
                    height: 40,
                    borderRadius: '8px',
                    lineHeight: '24px',
                    fontSize: '18px',
                    fontWeight: '700',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
                className="color-l background-color-b"
            >
                {selectedItemIds.length}
            </Box>
            <Typography sx={{ ml: 1 }} variant="s16w500" className="color-bd">
                {i18n.translate('Selected')}
            </Typography>
        </Box>

        <Box sx={{ display: 'flex', alignItems: 'center', height: '100%' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', mr: 3 }}>
                {actions.map((action, i) => (
                    <Button
                        key={i}
                        sx={{ whiteSpace: 'nowrap', border: '0px', fontSize: '16px', mr: 2 }}
                        startIcon={action.icon}
                        color="secondary"
                        onClick={() => action.actionFun(selectedItemIds)}
                        disabled={
                            (selectedItemIds.length > 1 && action.singleItemAction) ||
                            action.isItemsDisabled?.(selectedItemIds)
                        }
                    >
                        {typeof action.label === 'string' ? action.label : action.label(selectedItemIds)}
                    </Button>
                ))}
            </Box>

            <Box sx={{ height: '100%', display: 'flex', alignItems: 'center' }}>
                <Divider
                    sx={{ mr: 0.5, my: 1, borderRadius: '8px' }}
                    className="border-color-md"
                    variant="middle"
                    orientation="vertical"
                    flexItem
                />
                <IconButton onClick={onClearSelection}>
                    <IconXWindow className="fill-md" />
                </IconButton>
            </Box>
        </Box>
    </Box>
);

export default CustomDataGridActionsBar;
